const ArrowRight = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.600006 13.4001V8.6001L7.00001 7.0001L0.600006 5.4001V0.600098L15.8 7.0001L0.600006 13.4001Z"
      fill="white"
    />
  </svg>
);

export default ArrowRight;
